(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("seminarList", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/seminar/seminarListView.html",
            controller: ["authService", "frameworkService", "tenantFeaturesResource", "$state", "$scope", "$sessionStorage", "$timeout", "calendarSettingsService", "DTOptionsBuilder", "$localStorage", "$filter", "$translate", "_", SeminarListCtrl],
            controllerAs: "vm"
        };
        function SeminarListCtrl(authService, frameworkService, tenantFeaturesResource, $state, $scope, $sessionStorage, $timeout, calendarSettingsService, DTOptionsBuilder, $localStorage, $filter, $translate, _) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstance = {};
            vm.languages = frameworkService.data.tenant.enabledLocalizations;
            vm.statuses = [{ "id": 1, "status": "enabled" }, { "id": 0, "status": "disabled" }];
            //Check Roles if only facilitator only show those seminars for that facilitator
            //Check if Learning Item code (Seminar type) is provided if it is filter by the learning item name
            //If learning item code is provided when +New seminar is selected pass learning item code to select in seminar name drop down
            //Facilitator role only does not see +New Seminar
            //Buttons [Save] [Save and Create New]
            vm.code = $state.params.code;
            var hasSuperPower = _.includes(authService.authentication.roles, "Super Admin") ||
                _.includes(authService.authentication.roles, "Site Admin") ||
                _.includes(authService.authentication.roles, "Learning Item Admin");
            vm.isAddNewSeminarVisible = hasSuperPower;
            vm.isFacilitator = _.includes(authService.authentication.roles, "Facilitator");
            vm.accessGranted = false;
            if (_.includes(authService.authentication.roles, "Group Admin") && !hasSuperPower) {
                tenantFeaturesResource.getIsTenantStorefrontEnabled(function (isStoreFrontEnabled) {
                    if (isStoreFrontEnabled.value)
                        $state.go("main.accessDenied");
                    else
                        vm.accessGranted = true;
                });
            }
            else {
                vm.accessGranted = true;
            }
            vm.format = "yyyy-MM-dd";
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/learningItemSeminars/seminarListViewModel",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "POST",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[0].search.value = "";
                    if (vm.filters.startDate.enabled) {
                        var search = "";
                        if (vm.filters.startDate.fromValue)
                            search = moment(vm.filters.startDate.fromValue).utc().format("YYYY-MM-DD HH:mm");
                        search = search + "|";
                        if (vm.filters.startDate.toValue) {
                            search = search + moment(vm.filters.startDate.toValue).utc().format("YYYY-MM-DD HH:mm");
                        }
                        data.columns[1].search.value = search !== "|" ? search : "";
                    }
                    data.columns[2].search.value = vm.filters.seminarName.enabled ? vm.filters.seminarName.value : [];
                    if (vm.filters.deliveryLanguage.enabled) {
                        var selectedLang = vm.filters.deliveryLanguage.value.join("|");
                        data.columns[3].search.value = selectedLang;
                    }
                    //data.columns[2].search.value = vm.filters.deliveryLanguage.enabled ?  : -1;
                    data.columns[4].search.value = vm.filters.facilitator.enabled ? vm.filters.facilitator.value : "";
                    data.columns[5].search.value = vm.filters.facility.enabled ? vm.filters.facility.value : "";
                    data.columns[6].search.value = vm.filters.city.enabled ? vm.filters.city.value : "";
                    data.columns[7].search.value = vm.filters.selfEnroll.enabled ? vm.filters.selfEnroll.value.join("|") : "";
                    data.columns[9].search.value = vm.filters.status.enabled ? vm.filters.status.value.join("|") : "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("stateSaveParams", function (_settings, data) {
                //EXAMPLE datatables do not save state of column visibility
                data.columns.forEach(function (column) {
                    delete column.visible;
                });
            })
                .withOption("rowCallback", rowCallback)
                .withOption("order", [1, "desc"])
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumns = [
                { "data": null, "defaultContent": "", "class": "control", "orderable": false, "targets": 0 },
                {
                    "data": "startDate",
                    "class": "text-nowrap",
                    "render": function (data) {
                        return data != null ? $filter("date")(data, "mediumDate") : ""; // moment.utc(data).local().format(""MMM D, YYYY"") : "";
                    }
                },
                { "data": "seminarName" },
                {
                    "data": "deliveryLanguage",
                    "visible": vm.languages.length > 1,
                    "render": function (data) {
                        return $translate.instant("common.localization." + data.replace(/\s+/g, ''));
                    }
                },
                { "data": "facilitator" },
                { "data": "facility" },
                { "data": "city" },
                {
                    "data": "selfEnroll",
                    "class": "text-center",
                    "orderable": false,
                    "render": function (data) {
                        return $filter("checkboxIcon")(data);
                    }
                },
                {
                    "data": "numberOfAttendees",
                    "class": "text-center",
                    "orderable": false
                },
                {
                    "data": "isEnabled",
                    "class": "text-center",
                    "orderable": false,
                    "render": function (data) {
                        return $filter("checkboxIcon")(data);
                    }
                }
            ];
            vm.rowClickHandler = function (rowData) {
                $state.go("main.learningItems.editSeminar", { id: rowData.id });
            };
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $timeout(function () {
                    $("td:not(.control)", nRow).bind("click", function () {
                        $scope.$apply(function () {
                            vm.rowClickHandler(aData);
                        });
                    });
                });
                return nRow;
            }
            //Date picker Config
            vm.datePickerList = {
                startDateFrom: false,
                startDateTo: false
            };
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.openToggle = calendarSettingsService.openToggle;
            if ($sessionStorage.seminarListFilters) {
                if ($state.params.seminarName) {
                    $sessionStorage.seminarListFilters.seminarName.value = $state.params.seminarName;
                }
                vm.filters = $sessionStorage.seminarListFilters;
                if ($sessionStorage.seminarListFilters.startDate.fromValue)
                    vm.filters.startDate.fromValue = new Date($sessionStorage.seminarListFilters.startDate.fromValue);
                if ($sessionStorage.seminarListFilters.startDate.toValue)
                    vm.filters.startDate.toValue = new Date($sessionStorage.seminarListFilters.startDate.toValue);
            }
            else {
                vm.filters = {
                    seminarName: { enabled: true, value: $state.params.seminarName ? $state.params.seminarName : "" },
                    startDate: { enabled: true, fromValue: "", toValue: "" },
                    city: { enabled: false, value: "" },
                    deliveryLanguage: { enabled: false, value: [] },
                    facilitator: { enabled: false, value: "" },
                    selfEnroll: { enabled: false, value: [] },
                    facility: { enabled: false, value: "" },
                    status: { enabled: true, value: [1] }
                };
            }
            vm.reloadTable = function () {
                $timeout(function () {
                    $sessionStorage.seminarListFilters = vm.filters;
                    vm.dtInstance.reloadData();
                });
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.seminarListFilters = vm.filters;
                // reload only if filtered
                if (value && value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                if (vm.filters[filter].hasOwnProperty("value"))
                    vm.refreshFilter(vm.filters[filter].value);
                if (vm.filters[filter].hasOwnProperty("fromValue")) {
                    vm.refreshFilter(vm.filters[filter].fromValue + vm.filters[filter].toValue);
                }
            };
        }
    });
}());
